<button class="scroltop"><span class="fa fa-angle-up  relative" id="btn-vibrate"></span></button>